import useForm from "../../../../forms/hooks/useForm";

export default function useAutoApprovalRuleForm() {
	return useForm({
		defaultValues: {
			threshold: 0,
		},
	});
}
